import React from 'react';
import { YStack, View } from 'tamagui';

import { GlowCircle } from './GlowCircle';

interface TripleGlowBackgroundProps {
  gradientColors: string[];
}

export const TripleGlowBackground: React.FC<TripleGlowBackgroundProps> = ({ gradientColors }) => (
  <YStack
    position="absolute"
    width="100%"
    height="100%"
    alignItems="center"
    justifyContent="center"
    pointerEvents="none">
    <View
      style={{
        marginTop: 100,
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <GlowCircle
        size={220}
        color={gradientColors[1] || gradientColors[0]}
        style={{ position: 'absolute', right: -25 }}
      />
      <GlowCircle
        size={220}
        color={gradientColors[0]}
        style={{ position: 'absolute', left: -25 }}
      />
    </View>
    <GlowCircle size={220} color={gradientColors[2] || gradientColors[0]} />
  </YStack>
);
